import React from 'react'
import '../../../index.css'
import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider'
import ProgressBar from 'react-toolbox/lib/progress_bar/ProgressBar'


export const Loading = props => {
    return (
        <ThemeProvider theme={theme}>
            <div className="col-xs-12 loading">
                <div className='centeredContent'>
                    {(props.error) ? <p>Error</p> :
                        <p><ProgressBar type="circular" mode="indeterminate" multicolor/>Loading... {props.porcent}%</p>}
                </div>
            </div>
        </ThemeProvider>
    )
};


// WEBPACK FOOTER //
// ./src/components/Map/Common/Loading.js